import { isObject } from '../is-object';
export function isI18nData(obj) {
  if (!isObject(obj)) {
    return false;
  }
  return obj.type === 'i18n';
}